/**
 * The user's voice-engine choice, readable synchronously from anywhere.
 *
 * This exists to keep two things apart that would otherwise have to be the same
 * module. The speak path needs the choice *synchronously* — branching on it
 * costs nothing, but awaiting an IPC round-trip or a React render would delay
 * every spoken sentence. The persistence of that choice belongs in the TTS
 * settings store, which is a Zustand store wired through `mirroredStore` and so
 * drags in window-role tracking, Tauri event listeners, and cross-window
 * mirroring — none of which the speak path should have to load.
 *
 * So the store owns persistence and pushes each change in here; the voice code
 * reads it back out. This module deliberately imports nothing.
 */

export type VoiceEnginePreference = "kokoro" | "system";

let engine: VoiceEnginePreference | null = null;
let windowsVoiceId: string | null = null;

/** The chosen engine, or null to follow the machine default. */
export function voiceEnginePreference(): VoiceEnginePreference | null {
  return engine;
}

export function setVoiceEnginePreference(
  next: VoiceEnginePreference | null,
): void {
  engine = next;
}

/** The chosen Windows voice as its WinRT id, or null for the Windows default. */
export function windowsVoicePreference(): string | null {
  return windowsVoiceId;
}

export function setWindowsVoicePreference(next: string | null): void {
  windowsVoiceId = next;
}
